@if (isLoading.data) {
  <div class="xi-loader-container__center">
    <xi-animation [width]="200" [height]="200" [loop]="true" animation="cx_loader"></xi-animation>
  </div>
}

<div *transloco="let t; read: 'new-analysis'" class="xi-modal__container new-analysis__container">
  <div [style.display]="!isLoading.data ? 'block' : 'none'">
    @if (!isEditMode) {
      <h2 class="xi-modal__title">{{ t('title-create') }}</h2>
    }
    @if (isEditMode) {
      <h2 class="xi-modal__title">{{ t('title-update') }}</h2>
    }
  </div>

  <div class="xi-modal__content new-analysis__content">
    <div [style.display]="!isLoading.data ? 'block' : 'none'">
      @if (!isEditMode) {
        <p class="paragraph-regular text-center description">
          {{ t('description-create') }}
        </p>
      }
      @if (isEditMode) {
        <p class="paragraph-regular text-center description">
          {{ t('description-update') }}
        </p>
      }

      <form #newAnalysisForm="ngForm">
        <div class="flex-row">
          <div class="flex-col spaced">
            <xi-input-field
              [label]="t('analysis-name')"
              [placeholder]="t('enter-here')"
              name="name"
              [(ngModel)]="name"
              required
              [prePopulateStatus]="true"
              [status]="analysisNameStatus"
              (onChange)="onValidateAnalysisName()"
              appAutoFocus="xiInput"
            ></xi-input-field>
          </div>

          @if (!isEditMode) {
            <div class="flex-col spaced">
              <app-analysis-config-selector
                [preloadedGroupConfigs]="groupConfigurations"
                [collection]="collection.data"
                (selectedConfig)="selectedConfiguration = $event"
                (selectedRouteLang)="selectedRouteLanguage = $event"
                (isLoading)="isLoading.data = $event"
              ></app-analysis-config-selector>
            </div>
          }
        </div>

        <div class="flex-row notes">
          <div class="flex-col">
            <xi-text-area
              [(ngModel)]="notes"
              name="notes"
              [label]="t('notes')"
              [height]="100"
              [resize]="false"
            ></xi-text-area>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="xi-modal__actions new-analysis__actions">
    <xi-default-button
      [text]="!isEditMode ? t('start-analysis') : t('save-analysis')"
      [disabled]="!canSaveAnalysis(newAnalysisForm)"
      (onClick)="closeAndAnalyse()"
    ></xi-default-button>
  </div>
</div>
